import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActionSheetController, AlertController, NavParams, LoadingController, ToastController, ModalController, Platform} from '@ionic/angular';

import { Tax } from '../../../../models';
import { SalonService } from '../../../../services/salon.service';
import { Utilities } from '../../../../utilities/utilities';
import { UserService } from '../../../../services/user.service';
import { MaskitoOptions, MaskitoElementPredicateAsync } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';

@Component({
  selector: 'app-tax-form',
  templateUrl: './tax-form.component.html',
  styleUrls: ['./tax-form.component.scss'],
})
export class TaxFormComponent implements OnInit {

  public tax: Tax;

  public name: UntypedFormControl;

  public rate: UntypedFormControl;

  public appliesTo;

  public bizNo: UntypedFormControl;

  public taxForm: UntypedFormGroup;

  public submitted: boolean;

  percentageMask: MaskitoOptions;

  readonly maskPredicate: MaskitoElementPredicateAsync = async (el) =>
    (el as HTMLIonInputElement).getInputElement();


  public isIOS: boolean;

  constructor (private modalCtrl: ModalController,
              private navParams: NavParams,
              private salonService: SalonService,
              public platform: Platform,
              private userService: UserService,
              private formBuilder: UntypedFormBuilder,
              private alertController: AlertController,
              private loadingCtrl: LoadingController,
              private toastController: ToastController,
              private actionSheetCtrl: ActionSheetController) {
    this.tax = this.navParams.get('tax');
    this.name = new UntypedFormControl(this.tax.name, [Validators.required, Validators.maxLength(50)]);
    this.rate = new UntypedFormControl(Utilities.roundTo3Decimal(this.tax.rate * 100), [Validators.required]);
    this.appliesTo = this.tax.appliesTo+'';
    this.bizNo = new UntypedFormControl(this.tax.bizNo, [Validators.maxLength(50)]);
    this.taxForm = this.formBuilder.group({
      name: this.name,
      rate: this.rate,
      bizNo: this.bizNo
    });

    this.percentageMask = maskitoNumberOptionsGenerator({
      postfix: '%',
      precision: 2,
    });
  }

  public ngOnInit () {
    if(this.platform.is('ios')) this.isIOS = true;
  }

  public dismiss () {
    this.modalCtrl.dismiss();
  }

  public async save () {
    if (!this.taxForm.valid) {
      return;
    }

    const loader = await this.loadingCtrl.create({spinner: 'crescent'});
    loader.present();

    let tax = this.tax.setName(this.name.value);
    let rate: number =  Utilities.extractNumberFromString(this.rate.value);

    if (rate > 0) {
      // rate = Utilities.roundTo2Decimal(rate / 100);
      rate = rate / 100;
    }

    tax = tax.setRate(rate);
    tax = tax.setAppliesTo(parseInt(this.appliesTo, 10));
    tax = tax.setBizNo(this.bizNo.value);

    this.salonService.saveTax(tax)
      .subscribe({next:(tax: Tax) => {
        this.tax = tax;
        loader.dismiss().then(() => {
          const data = {
            action: 'save',
            tax: this.tax
          };
          this.modalCtrl.dismiss(data).then(async () => {
            const toast = await this.toastController.create({
              message: `Tax has been updated`,
              duration: 3000
            })
            toast.present();            
          });
        });
      },
      error:(err) => {
        loader.dismiss().then(async () => {
          const alert = await this.alertController.create(Utilities.getDefaultErrorMessageConfig())
          alert.present();
        });
  }});
  }

  public async deleteTax () {

    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Are you sure you want to delete this tax?',
      buttons: [
        {
          text: `Yes, delete this tax`,
          icon: 'trash',
          role: 'destructive',
          cssClass: 'sm-error',
          handler: () => {

            actionSheet.dismiss().then(async() => {
              const loader = await this.loadingCtrl.create({spinner: 'crescent'});
              loader.present();

              this.salonService.deleteTax(this.tax)
                .subscribe({next: (success) => {
                  loader.dismiss().then(() => {
                    const data = {
                      action: 'delete',
                      tax: this.tax
                    };

                    this.modalCtrl.dismiss(data).then(async () => {
                      const toast = await this.toastController.create({
                        message: `Tax has been deleted`,
                        duration: 3000
                      })
                      toast.present();            
                    });
                  });
                },
                error: (err) => {
                  loader.dismiss().then(async () => {
                    const alert = await this.alertController.create(Utilities.getDefaultErrorMessageConfig())
                    alert.present();
                  });
                }});
            });

            return false;
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => {
            actionSheet.dismiss();
            return false;
          }
        }
      ]
    });

    actionSheet.present();
  }


}
